import { ActionsMenu, ActionsMenuItem } from '@/components/ActionsMenu';
import TrashIcon from '@/components/Icons/TrashIcon';
import useDeleteModel from '@/hooks/useDeleteModel';
import { BasetenPageEnum, usePageSwitcher } from '@/routes';
import useSafeguardConfirmationDialog from '@/sections/Dialog/SafeguardConfirmation';

import { WorkspaceSections } from '../../types';
import { ActionsProps } from './types';

function Actions({ variant, modelId, modelName, doNotRedirect }: ActionsProps) {
  const goToPage = usePageSwitcher();
  const deleteModel = useDeleteModel();
  const safeguardConfirmationDialog = useSafeguardConfirmationDialog();

  async function handleDeleteModel() {
    const confirmed = await safeguardConfirmationDialog({
      title: 'Delete model',
      okText: 'Delete model',
      prompt:
        'This action will delete all deployments of this model. Any applications using this model will stop working as expected. You cannot undo this action. Are you sure you want to delete this model and all of its deployments?',
      validationText: modelName,
      validationHint: 'Type the model name to confirm',
    });

    if (confirmed) {
      await deleteModel(modelId);
      if (!doNotRedirect) {
        goToPage(BasetenPageEnum.Workspace, {
          section: WorkspaceSections.Models,
        });
      }
    }
  }

  return (
    <ActionsMenu variant={variant}>
      <ActionsMenuItem
        destructive
        onClick={handleDeleteModel}
        data-cy="model-card-setting-delete-btn"
        icon={<TrashIcon />}
      >
        Delete model
      </ActionsMenuItem>
    </ActionsMenu>
  );
}

export default Actions;
